import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import { config } from '@/config'
import { initSentry, SentryErrorBoundary } from '@/sentry'

// До createRoot: иначе ошибки самого рендера в Sentry не попадут.
initSentry()

// Заголовок вкладки — из runtime-конфига, а не из index.html: один и тот же
// бандл ездит между стендами, а имя проекта приходит из ENV.
document.title = config.appName

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('#root не найден в index.html')

createRoot(container).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<p>Что-то сломалось. Обновите страницу.</p>}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SentryErrorBoundary>
  </StrictMode>,
)
